<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="code">{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input
                  aria-describedby="codeField"
                  :state="errors.some((e) => e.field === 'code') ? false : null"
                  type="text"
                  id="code"
                  v-model="procedure.code"
                  aria-required="true">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="label">{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="procedure.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="description">{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="description" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="procedure.description"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="procedureType">{{$tc('title.procedureTypes', 0)}} <required-field /> </label>
                <v-select id="procedureType" v-model="procedure.procedureType" :options="procedureTypes"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="source">{{$tc('title.sources', 0)}} <required-field /> </label>
                <v-select id="source" v-model="procedure.source" :options="sources"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="enabled">{{ $tc('page.generic.state', 1) }} <required-field /></label> <br>
                <custom-switch
                  id="enabled"
                  class="mx-1"
                  v-model="procedure.enabled"
                  color="success"
                  variant="pill"
                  label/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createProcedure" :disabled="!isSaveEnabled">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'procedureRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import RequiredField from "../../components/RequiredField";
import ProcedureTypeService from "@/services/ProcedureTypeService";
import SourceService from "@/services/SourceService";
import ProcedureService from "@/services/ProcedureService";
import vSelect from 'vue-select'
import CustomSwitch from "@/components/CustomSwitch";

const sourceService = SourceService.build()
const procedureService = ProcedureService.build();
const procedureTypeService = ProcedureTypeService.build();

export default {
  name: 'ProcedureNew',
  inheritAttrs: false,
  components: {
    RequiredField,
    PageTitle,
    vSelect,
    CustomSwitch
  },
  data() {
    return {
      procedure: {
        enabled: false,
      },
      sources: [],
      procedureTypes: [],
      errors: []
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.getProcedureTypes();
    this.getSources();
  },
  computed: {
    isSaveEnabled() {
      return this.procedure.code && this.procedure.label && this.procedure.source && this.procedure.procedureType
    }
  },
  methods: {
    async createProcedure() {
      try {
        const newProcedure = await procedureService.create(   {
          code: this.procedure.code,
          label: this.procedure.label,
          description: this.procedure.description,
          enabled: this.procedure.enabled,
          procedureTypeCode: this.procedure.procedureType ? this.procedure.procedureType.code : '',
          sourceCode: this.procedure.source ? this.procedure.source.code : ''
        });
        this.$router.push({name: `procedureShowRoute`, params: {id: newProcedure.id}})
      } catch (exception) {
        this.errors = exception.errors;
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      }
    },
    async getProcedureTypes() {
      this.procedureTypes = (await procedureTypeService.search({ max: -1 })).data;
    },
    async getSources() {
      this.sources =  (await sourceService.search({ max: -1 })).data;
    },
  }
}
</script>

